var exports = {
  "k": "x804f0401--33c01e--container",
};

module.exports = exports;
